import React from "react";
import { AiOutlineShopping, AiOutlineShoppingCart } from "react-icons/ai";

const NoData = ({ title, type }) => {
  return (
    <div className="no_data_container">
      <h2 className="align">
        {type === "cart" ? <AiOutlineShoppingCart /> : <AiOutlineShopping />}{" "}
        {title}
      </h2>
    </div>
  );
};

export default NoData;
